import { http } from "../../services/client";

export interface NotificationItem {
  id: string;
  kind: string;
  title: string;
  body?: string | null;
  render_id?: string | null;
  read: boolean;
  created_at: string;
}

export function listNotifications(limit = 20): Promise<NotificationItem[]> {
  return http<NotificationItem[]>(`/notifications?limit=${limit}`);
}

export function unreadCount(): Promise<{ count: number }> {
  return http<{ count: number }>(`/notifications/unread-count`);
}

export function markRead(ids?: string[]): Promise<{ ok: boolean }> {
  return http<{ ok: boolean }>(`/notifications/read`, {
    method: "POST",
    body: JSON.stringify(ids ? { ids } : {}),
  });
}
